import { render } from "./FavouriteCategories.vue?vue&type=template&id=79d66ea0&scoped=true"
import script from "./FavouriteCategories.vue?vue&type=script&lang=js"
export * from "./FavouriteCategories.vue?vue&type=script&lang=js"

import "./FavouriteCategories.vue?vue&type=style&index=0&id=79d66ea0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79d66ea0"

export default script